import React, {useContext, useEffect, useState} from 'react';
import LeaveSummaryAdmin from "./leave-summary-admin-view";
import LeaveSummaryEmployee from "./leave-summary-employee-view";
import UserLoginContext from "../../../../context/userLoginContext";
import {useLeaveContext} from "../common/leaveContext";
import SupervisorLeaveSummaryView from "./leave-summary-supervisor-view";
import AccessDenied from "../../../../pages/error-pages/access-denied-error";

interface IEmployeeDetail {
    id: string,
    name: string,
}

export const COLOR_MAP: Record<string, string> = {
    GENERAL_LEAVE: 'rgb(255, 99, 132)',
    SICK_LEAVE: 'rgb(99, 211, 255)',
    CASUAL_LEAVE: 'rgb(255, 205, 86)',
    OPTIONAL_LEAVE: 'rgb(54, 162, 235)',
    MATERNITY_LEAVE: 'rgb(153, 102, 255)',
    PATERNITY_LEAVE: 'rgb(75, 192, 192)'
};

const LeaveSummary: React.FC = () => {
    const {user} = useContext(UserLoginContext);
    const isAdmin = user?.isAdmin;
    const {supervisor, isPersonalSummary} = useLeaveContext();

    const [employee, setEmployee] = useState<IEmployeeDetail | undefined>(undefined);

    const monthList: string[] = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    useEffect(() => {
        if (!isAdmin) {
            setEmployee({
                name: user?.name.firstName + " " + user?.name.lastName,
                id: user?.employeeId!
            });
        }
    }, [user]);

    return (
        (isAdmin) ?
            <LeaveSummaryAdmin
                monthList={monthList}
            />
            : (supervisor?.isSupervisor && !isAdmin && !isPersonalSummary) ?
            <SupervisorLeaveSummaryView
                supervisor={supervisor}
                monthList={monthList}
            />
            : (employee?.id) ?
                <LeaveSummaryEmployee
                    monthList={monthList}
                    employeeId={employee.id}
                /> :
                <AccessDenied/>
    );
};

export default LeaveSummary;
